<img alt="" src="assets/images/svgs/left-arrow.svg" />
